export const ALL_FEAT_KEYS = {
  MAIN_HOME_PAGE_1: "main_home_page_1",
  MAIN_HOME_PAGE_2: "main_home_page_2",
  MAIN_HOME_PAGE_3: "main_home_page_3",
  MAIN_HOME_PAGE_4: "main_home_page_4",
  DISTRIBUTED_SYSTEMS: "distributed.systems",
  HEADER_ALERTS: "header.alerts",
  MAP_USER_LOCATION: "map.user.location",
  MAP_DATA_LOCATION: "map.data.location",
  HEADER_LIVE_STATUS: "header.live.status",
  ASSET_ENTITY_INSPECTOR: "asset.entity.inspector",
  ASSET_ENTITY_INSPECTOR_SUMMARY: "asset.entity.inspector.summary",
  ASSET_ENTITY_INSPECTOR_ACTIONS: "asset.entity.inspector.actions",
  ASSET_ENTITY_INSPECTOR_USER: "asset.entity.inspector.user",
  ASSET_ENTITY_INSPECTOR_GEO_COMM: "asset.entity.inspector.geo.comm",
  ASSET_ENTITY_INSPECTOR_CONN: "asset.entity.inspector.conn",
  ASSET_ENTITY_INSPECTOR_TOP_DOMAIN_CAT:
    "asset.entity.inspector.top.domain.cat",
  ASSET_ENTITY_INSPECTOR_TOP_QUERIED_DOMAINS:
    "asset.entity.inspector.top.queried.domains",
  ASSET_ENTITY_INSPECTOR_TOP_BANDWIDTH:
    "asset.entity.inspector.top.service.bandwidth",
  ASSET_ENTITY_INSPECTOR_TOP_NOISY: "asset.entity.inspector.top.noisy.services",
  ASSET_ENTITY_INSPECTOR_PORT_PROT: "asset.entity.inspector.port.protocols",
  ASSET_ENTITY_INSPECTOR_ASSOCIATE_PORT:
    "asset.entity.inspector.associate.port",
  ASSET_ENTITY_INSPECTOR_TRAFFIC_PATTERN:
    "asset.entity.inspector.traffic.pattern",
  ASSET_ENTITY_INSPECTOR_AD_ATTR: "asset.entity.inspector.ad.attributes",
  ASSET_ENTITY_INSPECTOR_EXT_LOGS: "asset.entity.inspector.external.logs",
  ASSET_ENTITY_INSPECTOR_ANOMALIES: "asset.entity.inspector.anomalies",
  ASSET_ENTITY_INSPECTOR_ALERTS: "asset.entity.inspector.alerts",
  ASSET_ENTITY_INSPECTOR_OUTDATED: "asset.entity.inspector.outdated",
  ASSET_ENTITY_INSPECTOR_VULN: "asset.entity.inspector.vuln",
  ASSET_ENTITY_INSPECTOR_USER_ACCESS: "asset.entity.inspector.user.access",
  ASSET_ENTITY_INSPECTOR_SERVICES: "asset.entity.inspector.services",
  ASSET_ENTITY_INSPECTOR_INVENTORY: "asset.entity.inspector.inventory",
  ASSET_ENTITY_INSPECTOR_THREATSCORE: "asset.entity.inspector.threatscore",
  ASSET_ENTITY_INSPECTOR_THIRD_SCORE: "asset.entity.inspector.third.score",
  ASSET_ENTITY_INSPECTOR_NET_USERS: "asset.entity.inspector.network.user",
  ASSET_ENTITY_INSPECTOR_PLUGINS: "asset.entity.inspector.plugins",

  ID_INTEL_SUPER_USERS: "id.intel.super.user",
  ID_INTEL_TOTAL_USERS: "id.intel.total.user",
  ID_INTEL_SUPER_USERS__USR_DIR: "id.intel.super.user__user-directory",
  ID_INTEL_AD_ORG_UNITS: "id.intel.ad.org.units",
  ID_INTEL_AD_ORG_UNITS__USR_DIR: "id.intel.ad.org.units__user-directory",
  ID_INTEL_USERS_WATCHLIST: "id.intel.user.watchlist",
  ID_INTEL_USERS_WATCHLIST__USR_DIR: "id.intel.user.watchlist__user-directory",
  ID_INTEL_USER_LIST: "id.intel.user.list",
  ID_INTEL_USER_CRUD_TIMEFILTER: "id.intel.user.crud.timefilter",
  ID_INTEL_USER_CRUD: "id.intel.user.crud",
  ID_INTEL_ACT_CHART__USR_DIR: "id.intel.activity.chart__user-directory",
  ID_INTEL_GROWTH_CHART__USR_DIR: "id.intel.growth.chart__user-directory",
  ID_INTEL_USER_LIST__USR_DIR: "id.intel.user.list__user-directory",
  ID_INTEL_USER_CRUD__USER_DIR: "id.intel.user.crud__user-directory",

  TOP_DORMANT_USERS: "top.dormant.users",
  AD_USER_HIGH_LOGIN: "ad.user.high.login",
  AD_USER_NO_PASSWORD: "ad.user.no.password",
  AD_USER_NO_PASSWORD_EXPIRY: "ad.user.no.password.expired",
  AD_USER_EXPIRING_15_DAYS: "ad.user.expiring.15.days",
  ID_INTEL_USER_NO_PASSWORD_EXPIRY: "id.intel.user.no.password.expired",
  ID_INTEL_USER_LOGON_SCRIPT: "id.intel.user.logon.script",
  ID_INTEL_USER_EXPIRING_15_DAYS: "id.intel.user.expiring.15.days",
  ID_TOP_SECURITY_GROUP: "id.top.security.group",
  ID_INTEL_WIDGET_AD: "id.intel.widget.ad",
  ID_INTEL_USR_GROUP: "id.intel.user.group",
  ID_INTEL_USR_NOPASS_EXP: "id.intel.user.nopass.exp",
  ID_INTEL_NOTIFICATION: "id.intel.notification",
  ID_INTEL_AUTH_OVER_TIME: "id.intel.auth.over.time",
  ID_INTEL_USER_SECTION: "id.intel.user.section",
  ID_INTEL_USER_SECTION__USR_DIR: "id.intel.user.section__user-directory",
  ID_INTEL_PLUGIN_SECTION: "id.intel.plugin.section",
  ID_INTEL_WITH_MOST_ASSETS: "id.intel.with.most.assets",
  TOP_SECURITY_GROUPS: "top.security.groups",
  USERS_WITH_MOST_ASSETS: "users.with.most.assets",
  ID_INTEL_TOP_APPS: "id.intel.top.apps",
  ID_INTEL_TOP_DIR_AUDIT: "id.intel.top.dir.audit",
  ID_INTEL_TOP_EMAIL_USERS: "id.intel.top.email.users",
  ID_INTEL_TOP_GROUPS: "id.intel.top.groups",
  ID_INTEL_TOP_DIR_ROLES: "id.intel.top.dir.roles",
  ID_INTEL_TOP_USERS_NO_PASS_EXP: "id.intel.top.users.no.pass.exp",
  ID_INTEL_TOP_USERS_NO_PASS_EXP_2: "id.intel.top.users.no.pass.exp.2",
  ID_INTEL_USERS_AT_RISK: "id.intel.users.at.risk",
  ID_INTEL_USERS_AT_RISK_REDIS: "id.intel.users.at.risk.redis",
  ID_INTEL_USERS_AT_RISK_SQLITE: "id.intel.users.at.risk.sqlite",
  ID_INTEL_MOST_THREAT: "id.intel.most.threat",
  ID_INTEL_USER_CREATED: "id.intel.user.created",
  ID_INTEL_USER_DELETED: "id.intel.user.deleted",
  ID_INTEL_USER_ENABLED: "id.intel.user.enabled",
  ID_INTEL_USER_DISABLED: "id.intel.user.disabled",
  ID_INTEL_USER_LOCKED: "id.intel.user.locked",
  ID_INTEL_USER_UNLOCKED: "id.intel.user.unlocked",
  ENTITY_INSPECTOR: "entity.inspector",
  USER_INVESTIGATOR_ACCESS: "can_access_userInvestigator",
  USER_INVESTIGATOR_SMALL: "user.investigator.small",
  USER_INVESTIGATOR_WIDE: "user.investigator.wide",
  USER_INVESTIGATOR_SOURCE: "user.investigator.source",
  USER_INVESTIGATOR_HEATMAP: "user.investigator.heatmap",
  USER_INVESTIGATOR_HOSTS: "user.investigator.hosts",
  USER_INVESTIGATOR_NT: "user.investigator.nt",
  USER_INVESTIGATOR_ST: "user.investigator.st",
  USER_INVESTIGATOR_SUMMARY: "user.investigator.summary",
  USER_INVESTIGATOR_SUMMARYDATA: "user.investigator.summarydata",
  USER_INVESTIGATOR_SERVICES: "user.investigator.services",
  USER_INVESTIGATOR_SENSITIVE_INFO: "user.investigator.sentive.info",
  USER_INVESTIGATOR_ACTIONS: "user.investigator.actions",
  USER_INVESTIGATOR_ATTRIBUTES: "user.investigator.attributes",
  USER_INVESTIGATOR_ANOMALIES: "user.investigator.anomalies",
  USER_INVESTIGATOR_PEER_USERS: "user.investigator.peer.users",
  USER_INVESTIGATOR_USER_ACCESS: "user.investigator.user.access",
  USER_INVESTIGATOR_USER_GROUP: "user.investigator.user.group",
  USER_INVESTIGATOR_AZURE_USER_GROUP: "user.investigator.azure.user.group",
  USER_INVESTIGATOR_TABS: "user.investigator.tabs",
  USER_INVESTIGATOR_DATA_TABS: "user.investigator.data.tabs",
  USER_INVESTIGATOR_TIMEFRAME: "user.investigator.timeframe",

  HEADER_SEARCH_CHARTS: "header.search.charts",
  HEADER_SEARCH_ANOMALIES: "header.search.anomalies",
  HEADER_SEARCH_FILES: "header.search.files",
  SIDENAV_PLUGIN_DASHBOARD: "sidenav.plugin.dashboard",
  THREATSCORE_SCROLL_HEIGHT: "threatscore.scroll.height",
  THREATSCORE_MAIN_TITLE: "threatscore.main.title",
  THREATSCORE_TABLE: "threatscore.table",
  AML_PRIMARY_TAB: "aml.primary.tab",
  AML_TAB_NAME_1: "aml.tab.name.1",
  AML_TAB_NAME_2: "aml.tab.name.2",
  AML_SILO_AMLS: "aml.silo.amls",
  AML_ALLOW_EMPTY_SILO_ANOMALY: "aml.allow.empty.silo.anomaly",
  AML_ALLOW_EMPTY_ENTITY_ANOMALY: "aml.allow.empty.entity.anomaly",
  AML_ALLOW_EMPTY_ENTITY_ALERT: "aml.allow.empty.entity.alert",
  AML_ALLOW_EMPTY_USER_ANOMALY: "aml.allow.empty.user.anomaly",
  AML_ALLOW_EMPTY_USER_ALERT: "aml.allow.empty.user.alert",
  AML_SCROLL_HEIGHT: "aml.scroll.height",
  AML_MAIN_TITLE: "aml.main.title",
  AML_TIME_FILTER: "aml.time.filter",
  AML_ENTITY_STAGES: "aml.entity.stages",
  AML_MITRE_CAT: "aml.mitre.cat",
  AML_MITRE_ATTACK_DEFEND: "aml.mitre.attack.defend",
  AML_COMPLIANCE: "aml.compliance",
  AML_DASH_TOP_IPS: "aml.dash.top.ips",
  AML_DASH_TOP_ANOMALY_COUNTS: "aml.dash.top.anomaly.counts",
  AML_DASH_TOP_CATEGORIES: "aml.dash.top.categories",
  AML_DASH_TOP_USERS: "aml.dash.top.users",
  HOME_MAIN_TABLE: "home.main.table",
  HOME_ATTACK_DATA: "home.attack.data",
  USECASE_FIELDS_TO_SAVE_1: "usecase.fields.to.save.1",
  USECASE_FIELDS_TO_SAVE_2: "usecase.fields.to.save.2",
  USECASE_RULE_FUNCTIONS: "usecase.rule.functions",
  S360_TOP_VAL_CHART: "s360.top.val.chart",
  S360_HIDE_DEFLT_COLS: "s360.hide.deflt.cols",
  AML_USER_FIRST: "aml.user.first",
  ASSET_AUTO_C: "asset.auto.c",
  ASSET_AUTO_ENDPOINT_SECURITY: "asset.auto.endpoint.security",
  ASSET_AUTO_MANAGED_UNMANAGED: "asset.auto.managed.unmanaged",
  ASSET_AUTO_TOP_DOMAINS: "asset.auto.top.domains",
  ASSET_AUTO_OS: "asset.auto.os",
  ASSET_AUTO_DEVICE_TYPE: "asset.auto.device.type",
  ASSET_AUTO_MAC_VENDOR: "asset.auto.mac.vendor",
  ASSET_AUTO_DOMAIN_CATEGORY: "asset.auto.domain.category",
  ASSET_AUTO_TOP_ANOMALIES: "asset.auto.top.anomalies",
  ASSET_AUTO_RISKY_ASSETS: "asset.auto.risky.assets",
  ASSET_AUTO_RISKY_SUBNETS: "asset.auto.risky.subnets",
  ASSET_AUTO_APPS: "asset.auto.apps",
  ASSET_AUTO_OUTDATED_APPS: "asset.auto.outdated.apps",
  ASSET_AUTO_WATCHLIST: "asset.auto.watchlist",
  ASSET_AUTOS_MOST_QUERIED_TLD: "asset.autos.most.queried.tld",
  ASSET_AUTO_LEAST_QUERIED_TLD: "asset.auto.least.queried.tld",
  ASSET_AUTO_SUSPICIOUS_TLD: "asset.auto.suspicious.tld",
  ASSET_AUTO_TRAFFIC_TRENDS: "asset.auto.traffic.trends",
  ASSET_AUTO_TOP_SERVICES: "asset.auto.top.services",
  ASSET_AUTO_TOP_SERVICE: "asset.auto.top.service",
  ASSET_AUTO_WATCHLIST_2: "asset.auto.watchlist.2",
  DATA_REPO_CAT: "data.repo.cat",
  DATA_REPO_RETENTION: "data.repo.retention",
  DATA_REPO_SENSITIVE: "data.repo.sensitive",
  DATA_REPO_FILE_SMALL: "data.repo.file.small",
  DATA_REPO_SERVICE_SMALL: "data.repo.service.small",
  DATA_REPO_SERVICE_BIG: "data.repo.service.big",
  DATA_REPO_DUPLICATE: "data.repo.duplicate",
  DATA_REPO_DOWNLOAD_REPORT: "data.repo.download.report",
  DATA_REPO_OPEN_ACCESS_FILES: "data.repo.open.access.files",
  ID_INTEL_SUPERUSER_WIDE: "id.intel.superuser.wide",

  LIVESHADOW_STATUS_FULL: "liveshadow.status.full",

  LIVESHADOW_STATS_1_ANOMALY: "liveshadow.stats.1.anomaly",
  LIVESHADOW_STATS_1_EVENTS: "liveshadow.stats.1.events",
  LIVESHADOW_STATS_3_RESOURCE: "liveshadow.stats.3.resource",
  LIVESHADOW_STATS_3_DATA: "liveshadow.stats.3.data",
  LIVESHADOW_STATS_4_ASSET: "liveshadow.stats.4.asset",
  LIVESHADOW_STATS_5_SUBNET: "liveshadow.stats.5.subnet",
  LIVESHADOW_STATS_6_PLUGIN: "liveshadow.stats.6.plugin",
  LIVESHADOW_SENSITIVE_EXPOSURE: "liveshadow.sensitive.exposure",

  USER_DIR_ID_PROV: "user.dir.id.prov__user-directory",
  ID_INTEL_USER_RISK_STATUS: "id.intel.user.risk.status",
  ID_INTEL_USER_NO_PASS: "id.intel.user.no.password",
  DATA_EXPOSURE_SIDE_BAR: "data.exposure.side.bar",
  ID_INTEL_USER_RELATED: "id.intel.user.related",
  ID_INTEL_TOP_ROLES: "id.intel.top.roles",
  ID_INTEL_TOP_NO_PWD_USERS: "id.intel.top.no.pwd.users",
  ID_INTEL_GROUPS: "id.intel.groups",
  ID_INTEL_HIGH_FAILED_LOGIN: "id.intel.high.failed.login",
  ID_INTEL_CONNECTED_TO_MOST_ASSET: "id.intel.connected.most.assets",
  ID_INTEL_ITDR_USER_WIDGETS: "id.intel.itdr.widgets",
  ID_INTEL_RISKY_USER_SOURCE: "id.intel.riksy.user.source",
  ID_INTEL_EMPTY_GROUPS: "id.intel.empty.groups",
  ID_INTEL_AD_WIDGETS_BYPASS: "id.intel.ad.widgets.bypass",
  ID_INTEL_AZURE_WIDGETS_BYPASS: "id.intel.azure.widgets.bypass",
  GLOBAL_SEARCH: "global.search",
  SHADOW_GPT_FLOAT_PAGE: "shadowgpt.float.page",
  SHADOW_GPT_FLOAT_PAGE_AML: "shadowgpt.float.page.aml",
  SHADOW_GPT_FLOAT_PAGE_THREATSCORE: "shadowgpt.float.page.threatscore",
  SHADOW_GPT_FLOAT_USER_INVESTOGATOR: "shadowgpt.float.user.investigator",
  SHADOW_GPT_FLOAT_ASSET_DISCOVERY: "shadowgpt.float.asset.discovery",
  PLUGIN_ACTION_EVENTS: "plugin.action.events",
  PLUGIN_ACTION_FILE: "plugin.action.file",
  EVENT_ASSIGN_TO: "event.assign.to",

  IDENTITY_INTELLIGENCE_DROP_DOWN: "identity.intelligence.drop.down",
  FILE_INVESTIGATOR_DATA_LINEAGE: "file.investigator.data.lineage",
  AI_ENGINE_EVENT_CATEGORY: "alEngine.event.eventCategory",
  RULE_BUILDER_ANOMALY_SHOW_L1L2: "ruleBuilder.anomaly.showL1L2category",
  RULE_BUILDER_ANOMALY_SHOW_KILL_CHAIN: "ruleBuilder.anomaly.showKillChain",
} as const;

export type FeatureKey = (typeof ALL_FEAT_KEYS)[keyof typeof ALL_FEAT_KEYS];
